<div class="navbar">
  <div class="container-fluid">
    <ul class="navbar-nav flex-row">
      <li class="nav-item">
        <button class="btn" (click)="toggleSidebar.next()" type="button">
          <span class="fa fa-fw fa-bars"></span>
        </button>
      </li>
    </ul>

    <ul *ngIf="isLoggedIn" class="navbar-nav flex-row">
      <li class="nav-item text-light d-flex flex-column justify-content-center me-2">
        <span class="no-hover">
          <i class="fa fa-fw fa-info"></i> Version: {{ version }}
        </span>
      </li>
      <li class="nav-item">
        <button type="button" class="btn" (click)="menu.toggle($event)">
          <span class="glyphicon glyphicon-user"></span>&nbsp;
          {{ username }}&nbsp;
          <b class="caret"></b>
        </button>
        <p-menu #menu [popup]="true" [model]="items" appendTo="body"></p-menu>
      </li>
    </ul>
  </div>
</div>
